export const INITIALIZE_USER = "INITIALIZE_USER";
export const LOG_OUT_USER = "LOG_OUT_USER";
export const UPDATE_NAME_LAST_NAME = "UPDATE_NAME_LAST_NAME";